// extracted by mini-css-extract-plugin
module.exports = {"footer":"_3tTi8jT","attribute":"_1qp2pCK","attributeName":"_3K-QVdG","attributeValue":"_36f--PU"};